export const CharacterTranslationStatus = {
    PREPARE_TRANSLATION: "prepareTranslation",
    ANALYZE_CONTENT: "analyzeContent",
    TRANSLATE_TITLE: "translateTitle",
    TRANSLATE_PERSONA: "translatePersona",
    TRANSLATE_GREETING: "translateGreeting",
    FINALIZE_TRANSLATION: "finalizeTranslation",
    WAITING_FOR_CONFIRMATION: "waitingForConfirmation",
    COMPLETED: "completed",
};
export const TOTAL_TRANSLATION_DURATION = 45000;
export const POLL_STATUS_INTERVAL_TIME = 7000;
export const PROGRESS_INTERVAL_TIME = 1000;
export const SUCCESS_CALLBACK_DELAY = 1000;
export const MAX_PROGRESS = 100;
export const MAX_PROGRESS_WITH_BUFFER = 98;
export const ANALYZE_CONTENT_THRESHOLD = 15;
export const TRANSLATE_TITLE_THRESHOLD = 30;
export const TRANSLATE_PERSONA_THRESHOLD = 35;
export const TRANSLATE_GREETING_THRESHOLD = 65;
export const FINALIZE_TRANSLATION_THRESHOLD = 90;
